import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    'Custom Kitchens & Cabinets',
    'Legal Basements',
    'Bathroom Renovations',
    'TV Walls & Fireplace Units',
    'Flooring Services',
    'Professional Painting',
    'Wainscotting',
    'Architectural Drawings',
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_basement-legal/artifacts/tdpe6c83_IMG-20260320-WA0001.jpg"
                alt="N-Teek Home Renovations"
                className="h-16 w-auto object-contain bg-white/10 p-2 rounded-lg"
              />
            </div>
            <p className="text-gray-400 leading-relaxed mb-6 max-w-md">
              N-Teek Home Renovations Inc. is your trusted partner for all interior renovation needs.
              We transform residential and commercial spaces with expert craftsmanship and attention
              to detail.
            </p>
            <div className="mb-6">
              <div className="flex items-start gap-3 text-gray-400 mb-4">
                <MapPin className="w-5 h-5 text-[#0070C0] mt-1 flex-shrink-0" />
                <div>
                  <div className="font-semibold text-white">Office Address</div>
                  <div>5 Limestone Edge Lane</div>
                  <div>Brampton, ON, L6X0H2</div>
                </div>
              </div>
            </div>
            <div className="flex flex-col space-y-3">
              <a
                href="tel:+14372481943"
                className="flex items-center gap-3 hover:text-[#0070C0] transition-colors group"
              >
                <div className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center group-hover:bg-[#0070C0] transition-colors">
                  <Phone className="w-5 h-5" />
                </div>
                <div>
                  <div className="text-xs text-gray-500">Amrinder</div>
                  <div className="font-semibold">+1 437-248-1943</div>
                </div>
              </a>
              <a
                href="mailto:nteekrenos@gmail.com"
                className="flex items-center gap-3 hover:text-[#0070C0] transition-colors group"
              >
                <div className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center group-hover:bg-[#0070C0] transition-colors">
                  <Mail className="w-5 h-5" />
                </div>
                <div>
                  <div className="text-xs text-gray-500">Email Us</div>
                  <div className="font-semibold">nteekrenos@gmail.com</div>
                </div>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('hero')}
                  className="hover:text-[#0070C0] transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="hover:text-[#0070C0] transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('portfolio')}
                  className="hover:text-[#0070C0] transition-colors"
                >
                  Portfolio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="hover:text-[#0070C0] transition-colors"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="hover:text-[#0070C0] transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Our Services</h3>
            <ul className="space-y-3">
              {services.slice(0, 6).map((service, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection('services')}
                    className="hover:text-[#0070C0] transition-colors text-left"
                  >
                    {service}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} N-Teek Home Renovations Inc. All rights reserved.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <MapPin className="w-4 h-4 text-[#E52B2B]" />
              <span>Proudly serving Ontario, Canada</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
